import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';

import mainMenuJSON from '../../../assets/json/mainmenu.json';
import { UtilityService } from '../../services/utility.service';

@Component({
	selector: 'app-navigation-component',
	templateUrl: './navigation.component.html',
	styleUrls: ['./navigation.component.scss'],
	imports: [CommonModule]
})
export class NavigationComponent {
	navToggle = false;

	mainMenu = mainMenuJSON;

	private utilityService = inject(UtilityService);

	public toggleNav(): void {
		this.navToggle = !this.navToggle;
		this.utilityService.toggleNav(this.navToggle);
	}
}
